import { render, staticRenderFns } from "./BqTemplateHandler.vue?vue&type=template&id=389af0ca&scoped=true&"
import script from "./BqTemplateHandler.vue?vue&type=script&lang=js&"
export * from "./BqTemplateHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389af0ca",
  null
  
)

export default component.exports